module.exports = __webpack_public_path__ + "img/type4_bg1.c8c33bf4.png";